export const shoppingTipsArticleId = 195;
